import * as constants from "./actions";
import axios from "@/plugins/axios.js";

function getDefaultState() {
  return {
    marketChanges: {
      status: null,
      data: {},
      error: null,
    },
    marketChangesExcel: {
      status: null,
      data: {},
      error: null,
    },
    filterStockVin: {
      status: null,
      data: [],
      error: null,
    },
    filterLastLocation: {
      status: null,
      data: [],
      error: null,
    },
  };
}

const actions = {
  [constants.GET_MARKET_CHANGES]: async ({ commit }, payload) => {
    try {
      commit(constants.GET_MARKET_CHANGES);
      const response = await axios.get("marketPlaces/getMarketChanges", {
        params: payload,
      });
      commit(constants.GET_MARKET_CHANGES_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.GET_MARKET_CHANGES_ERROR, error);
      throw error.response;
    }
  },
  [constants.GET_MARKET_CHANGES_EXCEL]: async ({ commit }, payload) => {
    try {
      commit(constants.GET_MARKET_CHANGES_EXCEL);
      const response = await axios.get("marketPlaces/exportMarketChanges", {
        params: payload,
        responseType: "blob",
      });
      commit(constants.GET_MARKET_CHANGES_EXCEL_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.GET_MARKET_CHANGES_EXCEL_ERROR, error);
      throw error.response;
    }
  },
  [constants.GET_FILTER_STOCK_VIN]: async ({ commit }, payload) => {
    try {
      commit(constants.GET_FILTER_STOCK_VIN);
      const response = await axios.get("marketPlaces/getFilterStockVin", {
        params: payload,
      });
      commit(constants.GET_FILTER_STOCK_VIN_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.GET_FILTER_STOCK_VIN_ERROR, error);
      throw error.response;
    }
  },
  [constants.GET_FILTER_LAST_LOCATION]: async ({ commit }, payload) => {
    try {
      commit(constants.GET_FILTER_LAST_LOCATION);
      const response = await axios.get("marketPlaces/getFilterLasLocation", {
        params: payload,
      });
      commit(constants.GET_FILTER_LAST_LOCATION_SUCCESS, response);
      return response;
    } catch (error) {
      commit(constants.GET_FILTER_LAST_LOCATION_ERROR, error);
      throw error.response;
    }
  },
};

const mutations = {
  [constants.GET_MARKET_CHANGES]: (state) => {
    state.marketChanges.status = "fetching";
    state.marketChanges.error = null;
  },
  [constants.GET_MARKET_CHANGES_SUCCESS]: (state, data) => {
    state.marketChanges.status = "success";
    state.marketChanges.error = null;
    state.marketChanges.data = data;
  },
  [constants.GET_MARKET_CHANGES_ERROR]: (state, error) => {
    state.marketChanges.status = "error";
    state.marketChanges.error = error;
  },
  [constants.GET_MARKET_CHANGES_EXCEL]: (state) => {
    state.marketChangesExcel.status = "fetching";
    state.marketChangesExcel.error = null;
  },
  [constants.GET_MARKET_CHANGES_EXCEL_SUCCESS]: (state, data) => {
    state.marketChangesExcel.status = "success";
    state.marketChangesExcel.error = null;
    state.marketChangesExcel.data = data;
  },
  [constants.GET_MARKET_CHANGES_EXCEL_ERROR]: (state, error) => {
    state.marketChangesExcel.status = "error";
    state.marketChangesExcel.error = error;
  },
  [constants.GET_FILTER_STOCK_VIN]: (state) => {
    state.filterStockVin.status = "fetching";
    state.filterStockVin.error = null;
  },
  [constants.GET_FILTER_STOCK_VIN_SUCCESS]: (state, data) => {
    state.filterStockVin.status = "success";
    state.filterStockVin.error = null;
    state.filterStockVin.data = data;
  },
  [constants.GET_FILTER_STOCK_VIN_ERROR]: (state, error) => {
    state.filterStockVin.status = "error";
    state.filterStockVin.error = error;
  },
  [constants.GET_FILTER_LAST_LOCATION]: (state) => {
    state.filterLastLocation.status = "fetching";
    state.filterLastLocation.error = null;
  },
  [constants.GET_FILTER_LAST_LOCATION_SUCCESS]: (state, data) => {
    state.filterLastLocation.status = "success";
    state.filterLastLocation.error = null;
    state.filterLastLocation.data = data;
  },
  [constants.GET_FILTER_LAST_LOCATION_ERROR]: (state, error) => {
    state.filterLastLocation.status = "error";
    state.filterLastLocation.error = error;
  },
};

export default {
  state: getDefaultState(),
  actions,
  mutations,
};
